import React from 'react';
import './UndoButton.css';
import UndoIcon from '@mui/icons-material/Undo';

const UndoButton = ({ onUndo, canUndo }) => {
  return (
    <button
      className="undo-button"
      onClick={onUndo}
      disabled={!canUndo}
      aria-label="Undo"
    >
      <UndoIcon sx={{ fontSize: 20 }} />
    </button>
  );
};

export default UndoButton;

